import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import BenefitInformation from "../../pages/BenefitInformation";
import Channel from "../../pages/channel";
import Board from "../../pages/channel/Board";
import Combinations from "../../pages/channel/Combinations";
import CombinationsId from "../../pages/channel/CombinationsId";
import CommunityEach from "../../pages/channel/CommunityEach";
import CommunityList from "../../pages/channel/CommunityList";
import Functions from "../../pages/channel/Functions";
import FunctionsId from "../../pages/channel/FunctionsId";
import Ingredients from "../../pages/channel/Ingredients";
import IngredientsId from "../../pages/channel/IngredientsId";
import InquiryBoard from "../../pages/channel/InquiryBoard";
import InquiryBoardEach from "../../pages/channel/InquiryBoardEach";
import InquiryBoardEditor from "../../pages/channel/InquiryBoardEditor";
import Main from "../../pages/channel/Main";
import MyPage from "../../pages/channel/MyPage";
import Search from "../../pages/channel/Search";
import FindPassword from "../../pages/channel/user/FindPassword";
import Login from "../../pages/channel/user/Login";
import SignUp from "../../pages/channel/user/SignUp";
import SignUpSuccess from "../../pages/channel/user/SignUpSuccess";
import KakaoCall from "../../pages/channel/user/sns/KakaoCall";
import NaverCall from "../../pages/channel/user/sns/NaverCall";
import SnsSignUp from "../../pages/channel/user/SnsSignUp";
import Policy from "../../pages/common/Policy";
import Terms from "../../pages/common/Terms";
import Dashboard from "../../pages/Dashboard";
import DashboardNew from "../../pages/DashboardNew";
import EditBoard from "../../pages/EditBoard";
import EditChannel from "../../pages/EditChannel";
import Faq from "../../pages/Faq";
import LandingPage from "../../pages/LandingPage";
import Notice from "../../pages/Notice";
import NoticeId from "../../pages/Notice[id]";
import Page404 from "../../pages/Page404";
import Products from "../../pages/Products";
import AnalysisCategory from "../../pages/reports/AnalysisCategory";
import AnalysisContents from "../../pages/reports/AnalysisContents";
import AnalysisProducts from "../../pages/reports/AnalysisProducts";
import Reports from "../../pages/reports/Reports";
import SignInPage from "../../pages/SignInPage";
import kakao from "../../pages/user/sns/kakao";
import Naver from "../../pages/user/sns/naver";
import CommentManage from "../../pages/userManageGroup/CommentManage";
import GroupBuying from "../../pages/userManageGroup/GroupBuying";
import InquiryManage from "../../pages/userManageGroup/InquiryManage";
import InquiryManageDetail from "../../pages/userManageGroup/InquiryManageDetail";
import MissionCommentManage from "../../pages/userManageGroup/MissionCommentManage";
import UserAppPush from "../../pages/userManageGroup/UserAppPush";
import UserManage from "../../pages/userManageGroup/UserManage";
import UserMessage from "../../pages/userManageGroup/UserMessage";
import AuthRoute from "../../utils/AuthRoute";
import ChannelRoute from "../../utils/ChannelRoute";
import PublicRoute from "../../utils/PublicRoute";
import LandingLoginComponent from "../landing/LandingLoginComponent";
import LandingTogetherComponent from "../landing/LandingTogetherComponent";
import SignInComponent from "../signIn/SignInComponent";
import FindPasswordComponent from "../user/FindPasswordComponent";
import SellerMyGrade from "../user/SellerMyGrade";
import SellerMypage from "../user/SellerMypage";
import SignUpComponent from "../user/SignUpComponent";
import TogetherSignup from "../user/TogetherSignup";

import ShareLink from "./ShareLink";

const ContentComponent = ({ channelInfo }) => {
	const location = useLocation();
	const path = location.pathname;

	return (
		<Switch>
			<Route path="/benefit/information" component={BenefitInformation} />
			<PublicRoute path={"/share/:id"} component={ShareLink} />

			<PublicRoute exact path="/" restricted={true} component={LandingPage} />
			<PublicRoute exact path="/landing" component={LandingLoginComponent} />
			<PublicRoute
				exact
				path="/landing/together"
				component={LandingTogetherComponent}
			/>
			<PublicRoute
				exact
				path="/login"
				restricted={true}
				component={SignInPage}
			/>
			{/*<PublicRoute exact path="/login/test" component={SignInLoginComponent} />*/}
			<PublicRoute exact path="/login/before" component={SignInComponent} />
			<PublicRoute path={`/user/sns/kakao`} component={kakao} />
			<PublicRoute path={`/user/sns/naver`} component={Naver} />
			<Route path="/faq" component={Faq} />
			<Route path="/notice" component={Notice} />
			<PublicRoute path="/user/signup" component={SignUpComponent} />
			<Route path="/user/together/signup" component={TogetherSignup} />
			<PublicRoute path="/user/find" component={FindPasswordComponent} />

			<AuthRoute path="/user/mygrade" component={SellerMyGrade} />
			<AuthRoute path="/user/mypage" component={SellerMypage} />

			<PublicRoute
				exact
				path="/channel"
				component={() => Board({ channelInfo })}
			/>
			<PublicRoute
				exact
				path="/together/channel"
				component={(context) => Channel({ channelInfo, context })}
			/>

			<PublicRoute exact path="/together/channel/policy" component={Policy} />
			<PublicRoute exact path="/together/channel/terms" component={Terms} />

			<ChannelRoute
				exact
				path="/together/channel/ingredients"
				component={Ingredients}
				type={`ingredient`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/ingredients/detail/:id"
				component={IngredientsId}
				type={`ingredient`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/functions"
				component={Functions}
				type={`function`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/functions/detail/:id"
				component={FunctionsId}
				type={`function`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/combinations"
				component={Combinations}
				type={`combination`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/combinations/detail/:id"
				component={CombinationsId}
				type={`combination`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/communities"
				component={CommunityList}
				type={`community`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/community/:id"
				component={CommunityEach}
				type={`community`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/inquiry/board"
				component={InquiryBoard}
				type={`inquiry`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/inquiry/:id"
				component={InquiryBoardEach}
				type={`inquiry`}
			/>
			<ChannelRoute
				exact
				path="/together/channel/inquiry/board/update/:id"
				component={InquiryBoardEditor}
				type={`inquiry`}
			/>

			<ChannelRoute exact path="/together/channel/mypage" component={MyPage} />
			<ChannelRoute exact path="/together/channel/search" component={Search} />
			<ChannelRoute exact path="/together/channel/login" component={Login} />
			<ChannelRoute exact path="/together/channel/signup" component={SignUp} />
			<ChannelRoute
				exact
				path="/together/channel/signup/success"
				component={SignUpSuccess}
			/>
			<PublicRoute
				exact
				path="/together/channel/sns-signup"
				component={SnsSignUp}
			/>
			<PublicRoute
				exact
				path="/together/channel/user/sns/kakao"
				component={KakaoCall}
			/>
			<PublicRoute
				exact
				path="/together/channel/user/sns/naver"
				component={NaverCall}
			/>
			<ChannelRoute
				exact
				path="/together/channel/find/user"
				component={FindPassword}
			/>

			{/* 로그인 필요 */}
			<AuthRoute exact path="/dashboard" component={DashboardNew} />
			<AuthRoute exact path="/dashboard/hidden" component={Dashboard} />
			<AuthRoute exact path="/dashboard/new" component={DashboardNew} />
			<AuthRoute exact path="/products" component={Products} />
			<AuthRoute
				exact
				path="/reports_analysis/category"
				component={AnalysisCategory}
			/>
			<AuthRoute
				exact
				path="/reports_analysis/contents"
				component={AnalysisContents}
			/>
			<AuthRoute
				exact
				path="/reports_analysis/products"
				component={AnalysisProducts}
			/>
			<AuthRoute exact path="/reports" component={Reports} />
			<AuthRoute exact path="/edit/channel" component={EditChannel} />
			<AuthRoute exact path="/user_comment_manage" component={CommentManage} />
			<AuthRoute
				exact
				path="/user_mission_comment_manage"
				component={MissionCommentManage}
			/>
			<AuthRoute exact path="/group_buying" component={GroupBuying} />
			<AuthRoute exact path="/user_message" component={UserMessage} />
			<AuthRoute exact path="/user_app_push" component={UserAppPush} />
			<AuthRoute exact path="/user_manage" component={UserManage} />
			<AuthRoute exact path="/inquiry_manage" component={InquiryManage} />
			<AuthRoute
				exact
				path="/inquiry_manage/:id"
				component={InquiryManageDetail}
			/>
			<AuthRoute exact path="/edit/board" component={EditBoard} />
			{/*<AuthRoute exact path="/notice" component={Notice} />*/}
			{/*<AuthRoute exact path="/notice/:id" component={NoticeId} />*/}

			<Route path="/404" component={Page404} />
			<Route exact path="/@:id" component={Main} />
			{/*<PublicRoute path="*" component={LandingPage} restricted={true}/>*/}

			{path.includes("/together") ? (
				<Route path="*">
					<Redirect to={`/404`} />
				</Route>
			) : (
				<Route path="*">
					<PublicRoute component={LandingPage} restricted={true} />
				</Route>
			)}
		</Switch>
	);
};

export default ContentComponent;
